import Router from 'next/router';
import { memo, useCallback } from 'react';

import { useTrackClickedPublicBoardLink } from '@air/analytics';
import { Button } from '@air/primitive-button';
import { useAirModal } from '@air/provider-modal';

import { SignupModal } from '~/components/Modals/SignupModal/SignUpModal';

export const PublicSignUpButton = memo(() => {
  const [showSignUpModal] = useAirModal(SignupModal);
  const { trackClickedPublicBoardLink } = useTrackClickedPublicBoardLink();

  const onSignUpClick = useCallback(() => {
    showSignUpModal({
      accountCreationSource: 'share-link',
      ssoCallbackData: {
        url: Router.asPath,
      },
    });

    trackClickedPublicBoardLink({
      name: 'clicked login',
      page_area: 'banner',
      page_type: 'public board',
    });
  }, [showSignUpModal, trackClickedPublicBoardLink]);

  return (
    <Button
      appearance="outline"
      color="blue"
      data-testid="PUBLIC_VIEWER_SIGN_UP_CTA"
      onClick={onSignUpClick}
      size="small"
    >
      Sign up
    </Button>
  );
});

PublicSignUpButton.displayName = 'PublicSignUpButton';
